module.exports = __webpack_public_path__ + "cx.svg?4b68133b0c177539dba65b0dac738fcc";